import React from 'react'
import Logo from '../assets/img/logo-achemed.png'
import './componentsCss/LoadingBlock.css'
function LoadingBlock() {
    return (
        <div className='loading-block'>
            <img alt="logo" src={Logo} />
        </div>
    )
}

export default LoadingBlock;